/* ********** Category Tabs ********** */
export const CATEGORY_ACCESS_TAB_SLUG = "access"
export const CATEGORY_ACTIONS_TAB_SLUG = "actions"
export const CATEGORY_DELETED_SUBMISSIONS_TAB_SLUG = "deleted-submissions"
export const CATEGORY_FORM_BUILDERS_TAB_SLUG = "form-builders"
export const CATEGORY_FORMS_ORDER_TAB_SLUG = "forms-order"
export const CATEGORY_GENERAL_TAB_SLUG = "general"
export const CATEGORY_REPORTING_FIELDS_TAB_SLUG = "reporting-fields"
export const CATEGORY_SUBMISSION_STATUSES_TAB_SLUG = "submission-statuses"

/* ********** Facility Tabs ********** */
export const FACILITY_ATTRIBUTES_TAB_SLUG = "attributes"
export const FACILITY_AUDIT_TRAIL_TAB_SLUG = "audit-trail"
export const FACILITY_DEPARTMENTS_TAB_SLUG = "departments"
export const FACILITY_GENERAL_TAB_SLUG = "general"

/* ********** Form Builder Tabs ********** */
export const FORM_BUILDER_DESIGN_TAB_SLUG = "design"
export const FORM_BUILDER_FORM_SETTINGS_TAB_SLUG = "form-settings"
export const FORM_BUILDER_SUBMISSION_ACCESS_TAB_SLUG = "submission-access"
export const FORM_BUILDER_WORKFLOW_TAB_SLUG = "workflow"

/* ********** Form Submission Tabs ********** */
// Links to this tab are sent in task emails and task report exports, so its value must not change.
// Must match FrontEndTabs::FORM_SUBMISSION_ACTIVITIES_TAB_SLUG in app/lib/front_end_tabs.rb
export const FORM_SUBMISSION_ACTIVITIES_TAB_SLUG = "activities"
export const FORM_SUBMISSION_ATTACHMENTS_TAB_SLUG = "attachments"
export const FORM_SUBMISSION_AUDIT_TRAIL_TAB_SLUG = "audit-trail"
export const FORM_SUBMISSION_CONVERSATIONS_TAB_SLUG = "conversations"
export const FORM_SUBMISSION_SUBMISSION_ACCESS_TAB_SLUG = "submission-access"
export const FORM_SUBMISSION_SUBMISSION_TAB_SLUG = "submission"
export const FORM_SUBMISSION_SUPPLEMENTAL_TAB_SLUG = "supplemental"

/* ********** General Settings Tabs ********** */
// Must match FrontEndTabs::GENERAL_SETTINGS_ANSWER_OPTIONS_TAB_SLUG in app/lib/front_end_tabs.rb
export const GENERAL_SETTINGS_ANSWER_OPTIONS_TAB_SLUG = "answer-options"
export const GENERAL_SETTINGS_FACILITY_GROUP_CODES_TAB_SLUG = "facility-group-codes"
export const GENERAL_SETTINGS_GENERAL_TAB_SLUG = "general"
export const GENERAL_SETTINGS_QUESTION_TAGS_TAB_SLUG = "question-tags"
export const GENERAL_SETTINGS_SFTP_SETTINGS_TAB_SLUG = "sftp-settings"

/* ********** Group Tabs ********** */
export const GROUP_GENERAL_TAB_SLUG = "general"
export const GROUP_MEMBERS_TAB_SLUG = "members"
export const GROUP_WORKFLOWS_TAB_SLUG = "workflows"

/* ********** Survey Batch Tabs ********** */
export const SURVEY_BATCH_SETTINGS_TAB_SLUG = "settings"
export const SURVEY_BATCH_SUBMISSIONS_TAB_SLUG = "submissions"

/* ********** Survey Configuration Tabs ********** */
export const SURVEY_CONFIGURATION_BATCHES_TAB_SLUG = "batches"
export const SURVEY_CONFIGURATION_CONTACTS_TAB_SLUG = "contacts"
export const SURVEY_CONFIGURATION_SETTINGS_TAB_SLUG = "settings"

/* ********** User Tabs ********** */
export const USER_ACCESS_OVERVIEW_TAB_SLUG = "access-overview"
export const USER_ACTIONS_TAB_SLUG = "actions"
export const USER_ATTRIBUTES_TAB_SLUG = "attributes"
export const USER_DEPARTMENTS_TAB_SLUG = "departments"
export const USER_GENERAL_TAB_SLUG = "general"
export const USER_GROUPS_TAB_SLUG = "groups"
export const USER_HISTORICAL_ACCESS_TOOL_TAB_SLUG = "historical-access-tool"
export const USER_SIGN_IN_HISTORY_TAB_SLUG = "sign-in-history"
export const USER_WORKFLOWS_TAB_SLUG = "workflows"
